export class FileTypes {

  static readonly CSV = new FileTypes('CSV', '.csv', ['text/csv', 'application/vnd.ms-excel','application/csv','text/x-csv']);
  static readonly JSON = new FileTypes('JSON', '.json', ['application/json']);
  static readonly TEXT = new FileTypes('TEXT', '.txt', ['text/plain']);
  static readonly PNG = new FileTypes('PNG', '.png', ['image/png','image/x-png']);
  static readonly JPG = new FileTypes('JPG', '.jpg', ['image/jpeg','image/x-jpeg']);
  static readonly ICO = new FileTypes('ICO', '.ico', ['image/x-icon','image/vnd.microsoft.icon']);

  private readonly _type: string;
  private readonly _extension: string;
  private readonly _mimeTypesArray: string[];


  private constructor(type: string, extension: string, mime: string[]) {
    this._type = type;
    this._extension = extension;
    this._mimeTypesArray = mime;
  }

  get type(): string {
    return this._type;
  }

  get extension(): string {
    return this._extension;
  }

  get mimeTypesArray(): string[] {
    return this._mimeTypesArray;
  }
}